import React from "react";
import PropTypes from "prop-types";

import { Icon } from "rhombus-react";

export default function PlatformTab(props){
	const {
		children,
		isValid,
	} = props;

	let statusIcon = null;

	if(isValid !== undefined){
		if(isValid){
			statusIcon = <Icon name="success" className="status-icon success" />;
		} else {
			statusIcon = <Icon name="errorT" className="status-icon warning" />;
		}
	}

	return (
		<span className="tab-container">
			{children}
			{statusIcon}
		</span>
	);
}

PlatformTab.displayName = "PlatformTab";
PlatformTab.propTypes = {
	isValid: PropTypes.bool,
};
